import { QueryClient } from "@tanstack/react-query";

const queryConfig = {
  queries: {
    retry: false,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 600000, // Poll every 10 mins
    staleTime: 600000, // Data is fresh for 10 mins
    cacheTime: 900000 // Cache data for 15 mins
  }
};

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
